module.exports = __webpack_public_path__ + "media/images/4-966c135487aa3eb50bba547393c37be1.png";